import { Complement, ComplementGroup } from '@app/types';
import { ComplementGroupSelectionType } from '.';

export function getComplementGroupSubtitle(max: number, totalAmount: number) {
  if (max === -1) {
    return 'Selecione';
  }
  return `Escolha até ${max} ite${max === 1 ? 'm' : 'ns'} (${totalAmount}/${max})`;
}

export function getErrorMessage(min: number) {
  if (min === -1) {
    return 'Selecione';
  }
  return `Você deve selecionar no mínimo ${min} ite${min === 1 ? 'm' : 'ns'}`;
}

export function getComplementGroupSelectionType(group: ComplementGroup) {
  return group.minimo === 1 && group.maximo === 1
    ? ComplementGroupSelectionType.Select
    : ComplementGroupSelectionType.Amount;
}

export function getInitialSelectedComplement(complements: Complement[]) {
  return complements.find((complement) => complement.amount === 1) ?? null;
}
